import { deserialize } from "@/utils";

const TokenKey = "Agent-Token";
const AgentIdKey = "Agent-Id";
const AgentUserIdKey = "Agent-User-Id";
const AgentUserImportType = "Agent-User-Import-Type";
const TokenUserName = "Agent-User-Name";
const TokenResourceKey = "Agent-Resource";

let serialize = require("serialize-javascript");

export function getToken() {
  return window.localStorage.getItem(TokenKey);
}

export function setToken(token) {
  window.localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  window.localStorage.removeItem(TokenKey);
}

export function getAgentId() {
  return window.localStorage.getItem(AgentIdKey);
}

export function setAgentId(agentId) {
  window.localStorage.setItem(AgentIdKey, agentId);
}

export function removeAgentId() {
  window.localStorage.removeItem(AgentIdKey);
}

export function getAgentUserId() {
  return window.localStorage.getItem(AgentUserIdKey);
}

export function setAgentUserId(agentUserId) {
  window.localStorage.setItem(AgentUserIdKey, agentUserId);
}

export function removeAgentUserId() {
  window.localStorage.removeItem(AgentUserIdKey);
}

export function setUsername(username) {
  window.localStorage.setItem(TokenUserName, username);
}

export function getUsername() {
  return window.localStorage.getItem(TokenUserName);
}

export function removeUsername() {
  window.localStorage.removeItem(TokenUserName);
}

export function setUserImportType(userImportType) {
  window.localStorage.setItem(AgentUserImportType, userImportType);
}

export function getUserImportType() {
  return window.localStorage.getItem(AgentUserImportType);
}

export function removeUserImportType() {
  window.localStorage.removeItem(AgentUserImportType);
}

export function setResources(resources) {
  if (resources) {
    window.localStorage.setItem(TokenResourceKey, serialize(resources));
  }
}

export function getResources() {
  var ret = window.localStorage.getItem(TokenResourceKey);
  if (ret) {
    return deserialize(ret);
  }
  return ret;
}

export function removeResources() {
  window.localStorage.removeItem(TokenResourceKey);
}
